<template>
   <div class="base-input" :class="{ 'is-active': isActive }" @click="$emit('click')">
      <label for="">{{ label }} </label>

      <div class="base-input-inner-wrapper">
         <div class="base-input-inner-wrapper-left-section">
            <!-- Flag Icon (renders for both regular and selectBox) -->
            <i v-if="iconType === 'flag' && flagCode" class="flag-icon" :class="'flag-icon-' + flagCode"></i>
            <!-- Regular Icon (only for non-selectBox) -->
            <Icon v-else-if="!isSelectBox && iconName" :name="iconName" />

            <slot>
               <div class="text-wrapper">
                  <template v-if="value.length == 0 && !opaqValue">
                     <span class="opaq-value">{{ placeholder }}</span>
                  </template>
                  <span :class="opaqValue ? 'opaq-value-' : ''">{{ value }}</span>
               </div>
            </slot>
         </div>

         <template v-if="isLoading">
            <span class="g-radial-loader"></span>
         </template>

         <template v-if="isSelectBox">
            <Icon name="chevron-down" />
         </template>
      </div>
   </div>
</template>

<script>
export default {
   name: "BaseInput",
   props: {
      value: {},
      label: {
         type: String,
         default: "",
      },
      placeholder: {
         type: String,
         default: "",
      },
      iconName: {
         type: String,
         default: "",
      },
      iconType: {
         type: String,
         default: "icon", // "icon" or "flag"
      },
      flagCode: {
         type: String,
         default: "",
      },
      isSelectBox: {
         type: Boolean,
         default: false,
      },
      isActive: {
         type: Boolean,
         default: false,
      },
      isLoading: {
         type: Boolean,
         default: false,
      },
   },
   data() {
      return {
         opaqValue: false,
      };
   },
};
</script>

<style lang="scss" scoped>
.base-input {
   cursor: pointer;
   display: flex;
   flex-direction: column;
   width: inherit;
   overflow: hidden;

   label {
      margin-bottom: 0.5rem;
      font-weight: 500;
      color: var(--txt-color);
   }

   .g-radial-loader {
      border-color: var(--gray-500);
   }

   .base-input-inner-wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 0.5rem;
      height: 48px;
      border: 1.5px solid var(--gray-400);
      background-color: var(--gray-100);
      outline: 0.25rem solid transparent;
      border-radius: 8px;
      padding: 0 0.5rem;
      transition: border-color 0.2s ease;
      width: 100%;
      overflow: hidden;

      .base-input-inner-wrapper-left-section {
         display: inherit;
         align-items: inherit;
         gap: inherit;
         min-width: 0;
         flex: 1;
         // margin-left: 0.25rem;

         .flag-icon {
            flex-shrink: 0;
            width: 24px;
            height: 16px;
            margin-right: 0.25rem;
         }

         ::v-deep .ui-icon {
            flex-shrink: 0;
         }

         .text-wrapper {
            min-width: 0;
            flex: 1;
            overflow: hidden;

            span {
               color: var(--txt-color);
               white-space: nowrap;
               overflow: hidden;
               text-overflow: ellipsis;
               display: block;

               &.opaq-value {
                  color: var(--gray-400);
                  pointer-events: none;
               }
            }
         }
      }
   }

   &:hover .base-input-inner-wrapper {
      // border: 1px solid var(--accent-primary);
      // outline: 0.25rem solid var(--accent-primary-lighten);
      background-color: var(--gray-0);
   }

   &.is-active .base-input-inner-wrapper {
      border: 1px solid var(--accent-primary);
      outline: 0.25rem solid var(--accent-primary-lighten);
   }
}
</style>
